import { useSwitchNetworkLoading } from '@/hooks/useSwitchNetworkLoading'
import { useSetAtom } from 'jotai'
import { useActiveChainId } from '@/hooks/useActiveChainId'
import { hideWrongNetworkModalAtom } from './NetworkModal'
import { Button, buttonVariants } from '@/components/ui/button'
import * as React from 'react'
import type { VariantProps } from 'class-variance-authority'
import { useTranslation } from '@pancakeswap/localization'

export const ForgeButton = ({
  asChild = false,
  ...props
}: React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean
  }) => {
  const { t } = useTranslation()
  const { isWrongNetwork } = useActiveChainId()
  const [switchNetworkLoading] = useSwitchNetworkLoading()
  const setHideWrongNetwork = useSetAtom(hideWrongNetworkModalAtom)

  if (isWrongNetwork) {
    return (
      <Button
        disabled={switchNetworkLoading}
        onClick={() => {
          setHideWrongNetwork(false)
        }}
      >
        {t('Wrong Network')}
      </Button>
    )
  }

  return (
    <Button
      {...props}
      onClick={(e) => {
        props.onClick?.(e)
      }}
    />
  )
}
